const tours = {
  availableEscapes: "Beschikbare ontsnappingen", // translated
  addOns: "Add-ons", // translated
  availableExperiences: "Beschikbare ervaringen", // translated
  addOn: "Toevoegen", // translated
  getRequest: "Verzoek ontvangen", // translated
  sendRequest: "Verzend verzoek", // translated
  tours: "Rondleidingen", // translated
  tour: "Tour", // translated
  selectRoom: "Selecteer een kamer", // translated
};


export default tours;
